import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import TableHelper from 'helpers/Table';
import { Table, Pagination, Badge, Icon } from 'antd';
import classes from '../styles/ScheduleInfo.module.scss';
import { Link } from 'react-router';
import { formatNumber } from 'utils/formatting';
import formatDate from 'utils/formatDate';
import _ from 'lodash';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const formatTime = (timeNumber) => {
  return moment(`${timeNumber}`, 'Hmm').format('HH:mm');
};
const formatDiscountRow = (order, orderDiscount) => {
  if (orderDiscount.type === 'multiple_student') {
    const discountPrice = order.fullPrice - orderDiscount.price;
    const students = _.clone(order.students);
    students.shift();
    return { text: `ซื้อ ${order.seats} ที่นั่ง ลดเหลือ ${formatNumber(discountPrice)} บาท\n`, type: 'multiple_student', students };
  }
  if (orderDiscount.type === 'earlybird') {
    const discountPrice = order.fullPrice - orderDiscount.price;
    return { text: `ใช้ ส่วนลด Early bird ลดเหลือ ${formatNumber(discountPrice)} บาท` };
  }
  return null;
};

const columns = [
  {
    ...TableHelper.defaultColumn('Order\nCode', 'code'),
    render: (value, record) => {
      if (!value) return '';
      return (
        <div>
          <Link to={`/order/${record._id}`}>{`${value}`}</Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      );
    },
  },
  {
    ...TableHelper.dateColumn('Order\nDate', 'createdAt'),
    sorter: true,
  },
  {
    ...TableHelper.defaultColumn('Student', 'student.name'),
    render: (value, record) => {
      if (!value) return '';
      const detail = [];
      if (record.discountList) {
        record.discountList.forEach((orderDiscount) => {
          const discountRow = formatDiscountRow(record, orderDiscount);
          if (discountRow) {
            detail.push(discountRow);
            // console.log(discountRow);
          }
        });
      }
      if (record.additionalList) {
        record.additionalList.forEach((additionalProduct) => {
          const additionalRow = { text: `${additionalProduct.type} ราคา ${additionalProduct.price} บาท` };
          if (additionalRow) {
            detail.push(additionalRow);
            // console.log(additionalRow);
          }
        });
      }

      return (
        <div>
          <Link to={`/student/${record.student._id}`}>{`${value.first} ${value.last}`}</Link>
          {detail.map((singleDetail) => (
            <div>
              <div>- {singleDetail.text}</div>
              {singleDetail.type === 'multiple_student' &&
                singleDetail.students.map((student) => (
                  <div>
                    &nbsp;&nbsp;&nbsp;-&nbsp;
                    <Link to={`/student/${student._id}`}>{student.email}</Link>{' '}
                  </div>
                ))}
            </div>
          ))}
        </div>
      );
    },
  },
  {
    ...TableHelper.defaultColumn('Sex', 'student.gender'),
  },
  {
    ...TableHelper.defaultColumn('Age', 'student.birthday'),
    render: (value) => {
      if (!value) return '';
      const age = moment().diff(moment(value), 'years');
      return age;
    },
  },
  {
    ...TableHelper.integerColumn('Learned', 'student.studiedWithTeacherCount'),
    render: (value, record) => {
      if (record.paymentMethod === 'Total') {
        return '';
      }
      const learned = record.learned || record.learned === 0 ? record.learned : value;
      return learned ? formatNumber(learned, '0,0') : 0;
    },
  },
  {
    ...TableHelper.defaultColumn('Status', 'status'),
    render: (value) => {
      if (value === 'Total') return value;
      return (
        <div>
          {value === 'pending' && <Badge status="default" text="Pending" />}
          {value === 'confirm' && <Badge status="warning" text="Confirmed" />}
          {value === 'paid' && <Badge status="processing" text="Paid" />}
          {value === 'success' && <Badge status="success" text="Success" />}
          {value === 'rejected' && <Badge status="error" text="Cancelled" />}
          {value === 'refunded' && <Badge status="warning" text="Refunded" />}
        </div>
      );
    },
    sorter: true,
  },
  {
    ...TableHelper.defaultColumn('Payment\nMethod', 'paymentMethod', true),
    render: (value) => {
      if (value === 'Total') return value;
      return (
        <div>
          {value === 'transfer' && 'Transfer'}
          {value === 'cc' && 'Credit Card'}
        </div>
      );
    },
  },
  {
    ...TableHelper.priceColumn('Promo\nCode', 'promocodeDiscountAmount'),
    render: (value, record) => {
      if (value === 'Total') return value;
      return (
        <div>
          <div>{formatNumber(value, '0,0.00')}</div>
          {record.promocode && <div>[{record.promocode}]</div>}
        </div>
      );
    },
  },
  {
    ...TableHelper.integerColumn('T-Points', 'points'),
  },
  {
    ...TableHelper.priceColumn('Amount\nDue', 'paidPrice'),
  },
  {
    ...TableHelper.priceColumn('Teacher’s\nRev', 'organicPrice'),
    // render: (value, record) => {
    //   if (record.serviceFee === 0) {
    //     return '-';
    //   }
    //   return `${formatNumber(record.paidPrice - record.serviceFee, '0,0.00')}`;
    // },
  },
  {
    ...TableHelper.priceColumn('Net Com', 'serviceFee'),
  },

  {
    ...TableHelper.priceColumn('Proc.\nFee', 'cardFee'),
  },
];

const ScheduleStudents = ({ schedule, orders, onChange }) => {
  // const orders = orders.results;
  console.log(onChange);

  const studyHour = _.get(schedule, 'flexibleDetail.studyHour');
  const studyMinute = _.get(schedule, 'flexibleDetail.studyMinute');
  const content = orders.map((offeringSchedule) => {
    offeringSchedule.studyHour = studyHour;
    offeringSchedule.studyMinute = studyMinute;
    return offeringSchedule;
  });
  const summaryData = content.reduce(
    (result, order) => {
      if (order.status === 'paid' || order.status === 'success') {
        result.paidPrice += order.paidPrice;
        result.organicPrice += order.organicPrice || 0;
        result.serviceFee += order.serviceFee || 0;
        result.cardFee += order.cardFee;
        result.points += order.points;
      }
      return result;
    },
    {
      paidPrice: 0,
      organicPrice: 0,
      serviceFee: 0,
      cardFee: 0,
      points: 0,
    },
  );
  content.push({
    paymentMethod: 'Total',
    ...summaryData,
  });
  return (
    <div className={cn('content')}>
      <div>
        <Table columns={columns} dataSource={content} bordered pagination={false} onChange={onChange} scroll={{ x: 1500 }} />
      </div>
    </div>
  );
};
// ScheduleStudents.propTypes = {
//   schedule: PropTypes.any,
//   orderResults: PropTypes.any,
// };

export default ScheduleStudents;
